import AccountSettingsPage from '../pages/Account/AccountSettingsPage'
import React from 'react'
import { safeLazy } from '../utils/SafeLazy/SafeLazy'
import ChunkLoader from '../components/ChunkLoader/ChunkLoader'

export const SETTINGS = '/settings',
	INTEGRATIONS = 'integrations',
	COMMUNICATION = 'communication',
	BILLING = 'billing'

const ProfileSection = safeLazy(() => import('../pages/Account/sections/profile/ProfileSection'))
const CommunicationSection = safeLazy(() => import('../pages/Account/sections/communication/CommunicationSection'))
const IntegrationsSection = safeLazy(() => import('../pages/Account/sections/integrations/IntegrationsSection'))
const BillingSection = safeLazy(() => import('../pages/Account/sections/billing/BillingSection'))

export const SETTINGS_ROUTES = [
	{
		path: SETTINGS,
		element: <AccountSettingsPage />,
		children: [
			{
				path: '',
				element: (
					<ChunkLoader>
						<ProfileSection />
					</ChunkLoader>
				),
			},
			{
				path: INTEGRATIONS,
				element: (
					<ChunkLoader>
						<IntegrationsSection />
					</ChunkLoader>
				),
			},
			{
				path: COMMUNICATION,
				element: (
					<ChunkLoader>
						<CommunicationSection />
					</ChunkLoader>
				),
			},
			{
				path: BILLING,
				element: (
					<ChunkLoader>
						<BillingSection />
					</ChunkLoader>
				),
			},
		],
	},
]
